module.exports = __webpack_public_path__ + "img/supersport-united-fc.c9a2db1a.png";